import { View } from 'react-native';
import BottomAreaTip from '../../BottomAreaTip';
import { KText, KView } from '@/component/RtlLayout';
import React, { useEffect, useState } from 'react';
import { showFlashActivity, useGetSellerParams } from '../../../utils';
import { useQuery } from '@/hooks/useQuery';
import { logClickBuyNowSpec, logClickSpecAddCart, logClickSpecHalfAddCart, logClickSpecHalfBuyButton } from '@/page/detail/views/logger2.0';
import { useDebounceFn, useMemoizedFn } from 'ahooks';
import { AdjustPCStyle, isInApp, isMobileDeviceValue, PCMaxWidth } from '@/common/device-info';
import { useCallApp } from '@/common/callApp';
import yoda from '@kibt/bridge';
import { useDetailPageStore } from '@/page/detail/store';
import { Toast } from '@kibt/meta-ui-krn';
import { $k18n } from '@/common/i18n';
import { PageRowData, Sku, getBuyShopStatus, claimSelfMultiBuildCouponToB } from '@/page/detail/views/api';
import { useLockBuyBtn } from '../../../hooks/useLockBuyBtn';
import { radar, webLogger } from '@/common/log';
import { useJumpToConfirmOrder } from '@/page/detail/views/jump';
import { useSubsidy } from '../../../hooks/useSubsidy';
import { ActivityType } from '../../BigMarketingBanner/CaculateBlock';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';

interface OptionButtonProps {
    pageRawData: PageRowData;
    selectedKV: { [key: string]: number };
    currentSku: Sku;
    purchaseQuantity: number;
    type: string;
    immediateAvailableQuantity: number;
    isFrom: string;
    showCartAndCheckout: boolean;
    pageActiveStatus: number;
    addCartItem: Function;
    addToCartAnimation: Function;
    openHalfConfirmOrder: boolean;
    retrievalInfo: any;
    extParamsCustom: any;
    customConfirm: Function;
    isReco: boolean;
    sellerMerchantId: number | string;
    sellerUserId: number | string;
}
export function OptionBarButton(props: OptionButtonProps) {
    const {
        pageRawData = {} as PageRowData,
        selectedKV,
        currentSku,
        purchaseQuantity,
        type,
        immediateAvailableQuantity,
        isFrom,
        showCartAndCheckout,
        pageActiveStatus,
        addCartItem,
        addToCartAnimation,
        openHalfConfirmOrder,
        retrievalInfo,
        extParamsCustom,
        customConfirm,
        isReco,
        sellerUserId,
        sellerMerchantId,
    } = props;
    const [disabled, setDisabled] = useState(true);
    const minNum = (pageRawData?.minPurchase as number) ?? 1;
    const isToBDetail = useQuery('pageType') === 'seller';

    const skuOverActivityLimit =
        pageRawData?.activityInfo?.activityId &&
        showFlashActivity(pageRawData?.activityInfo?.status) &&
        pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId] >= 0 &&
        purchaseQuantity > pageRawData?.activityInfo?.skuLimitCount?.[currentSku?.skuId];
    useEffect(() => {
        const comfirmDisabled = !pageRawData.specs.every(spec => {
            console.log(selectedKV[spec?.specId] !== null, spec.specId);
            return selectedKV[spec?.specId] && selectedKV[spec?.specId] !== null;
        });
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            setDisabled(comfirmDisabled || skuOverActivityLimit);
        } else {
            // 库存小于最小起购，购买置灰
            setDisabled(
                Number(immediateAvailableQuantity) === 0 || Number(immediateAvailableQuantity) < minNum || comfirmDisabled || skuOverActivityLimit
            );
        }
    }, [selectedKV, pageRawData, immediateAvailableQuantity, currentSku, purchaseQuantity, type, minNum]);

    const rtlClassName = ['optionbar_bar_bottom_btn', disabled ? 'optionbar_bar_bottom_btn_disabled' : ''];
    const miniBtnClassName = ['optionbar_bar_bottom_btn_mini', disabled ? 'optionbar_bar_bottom_btn_mini_disabled' : ''];
    const primaryMiniBtnClassName = ['optionbar_bar_bottom_btn_mini_primary', disabled ? 'optionbar_bar_bottom_btn_mini_disabled' : ''];
    const innerShowCartAndCheckout =
        currentSku?.skuId &&
        pageRawData.abTest?.multipulButtonForSpecHalfScreen &&
        currentSku?.activityPrice * purchaseQuantity >= pageRawData?.shippingFeeView?.threshold &&
        pageRawData.shippingFeeView?.threshold;
    const queryItemId = useQuery('itemId');
    const extParams = useQuery<string>('extParams');
    const { callApp } = useCallApp();
    const { lockRef, setLock } = useLockBuyBtn();
    const getStoreState = useDetailPageStore()?.getState;
    const { hasSubsidy } = useSubsidy(currentSku, pageRawData);
    const isSendSampleOrder = isToBDetail && useDetailPageStore?.getState()?.showSampleButton; // 1元寄样订单

    // 命中商详页返回时引导加购弹窗时，增加'popup'类型的埋点上报
    const addType = getStoreState().alertVisible?.specPupoup ? 'popup' : '';
    const resetAlertVisibleType = () => {
        getStoreState().setAlertVisible({
            ...getStoreState().alertVisible,
            specPupoup: false,
        });
    };
    const { jumpToConfirmOrder } = useJumpToConfirmOrder();
    const { sellerMerchantId: sellerMerchantIdFromQuery, sellerUserId: sellerUserIdFromQuery } = useGetSellerParams();
    const buyNowStatus = useMemoizedFn(async (itemId, skuId) => {
        let flag = true;

        const ext = extParams || '';

        await getBuyShopStatus({
            itemId,
            skuId,
            extParams: ext,
            sellerUserId: Number(sellerUserId || sellerUserIdFromQuery || 0),
            merchantId: Number(sellerMerchantId || sellerMerchantIdFromQuery || 0),
        })
            .then(res => {
                if (
                    res.data.shopStatus === 2 ||
                    res.data.shopBusinessStatus === 2 ||
                    res.data.stock <= 0 ||
                    res.data.activeStatus !== 2 ||
                    res.data.auditStatus !== 2
                ) {
                    flag = false;
                    if (res.data.shopBusinessStatus === 1 && res.data.shopStatus === 1) {
                        if (res.data.activeStatus !== 2 && res.data.auditStatus === 2) {
                            Toast.show({
                                text: $k18n('抱歉，商品已下架'),
                                duration: 3000,
                            });
                        } else if (res.data.activeStatus === 2 && res.data.auditStatus === 2 && res.data.stock <= 0) {
                            Toast.show({
                                text: $k18n('抱歉，商品已售罄'),
                                duration: 3000,
                            });
                        } else {
                            Toast.show({
                                text: $k18n('糟糕！商品找不到啦'),
                                duration: 3000,
                            });
                        }
                    } else {
                        Toast.show({
                            text: $k18n('糟糕！商品找不到啦'),
                            duration: 3000,
                        });
                    }
                }
            })
            .catch(err => {
                // context.emit('changLoding', false);
                flag = false;
                // 全局拦截器处理错误提示
                // showToast({
                //     text: (err.message as string)?.substring(0, 100),
                //     duration: 3000,
                // });
            });

        return flag;
    });
    const addToCart = useMemoizedFn(async () => {
        // 规格业务埋点监控

        radar.event({
            name: 'common_spec_confirm_click',
        });
        // 端外购买的话 需要唤起端内
        if (!isInApp) {
            return callApp({ pageId: 'ecomm_commodity_detail' });
        }

        // 未登陆需要登陆
        const res = await yoda.component.login({});
        if (res?.result !== 1) {
            return;
        }

        const skuId = currentSku.skuId;
        if (!skuId) {
            return;
        }
        if (Number(immediateAvailableQuantity) === 0) {
            if (!pageRawData?.extraInfo?.selfOperated && type === 'cart') {
                return;
            }
        }
        const { itemId } = currentSku;
        const buyamount = Math.max(purchaseQuantity, purchaseQuantity);

        logClickSpecAddCart({
            item_id: itemId,
            sku_id: skuId,
            sku_num: buyamount,
            type: addType,
            source: Number(queryItemId) === Number(pageRawData.itemId) ? 'current' : isReco ? 'recommend' : '',
            releated_item_id: String(queryItemId),
        });
        resetAlertVisibleType();

        let shopFlag;
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            shopFlag = true;
        } else {
            shopFlag = await buyNowStatus(itemId, skuId);
        }

        if (shopFlag) {
            // 调用外层加入购物车接口
            const result = await addCartItem?.(currentSku, buyamount);
            if (result && addToCartAnimation) {
                addToCartAnimation(currentSku.templateImageUrl || currentSku.imageUrl || pageRawData.templateImageUrl || pageRawData.itemImageUrl);
            }
            return result;
        }
        return false;
    });

    const onJumpToConfirmOrder = useMemoizedFn(async ({ addressId, buyamount, merchantId, skuId, itemId, poc, backendDispatchUrl = '' }) => {
        if (lockRef.current) {
            webLogger.sendLog({
                type: 'click',
                name: 'dumplicateSubmit',
                value: {
                    page: 'Detail:SpecLinePop',
                    status: 0,
                    time: Date.now(),
                },
            });
            return;
        }
        webLogger.sendLog({
            type: 'click',
            name: 'dumplicateSubmit',
            value: {
                page: 'Detail:SpecLinePop',
                status: 1,
                time: Date.now(),
            },
        });
        setLock(true);
        const needDelay = false;
        const flashSaleActivityId =
            pageRawData?.activityInfo?.activityId && pageRawData?.activityInfo?.status === 2 && pageRawData?.activityInfo?.saleRate < 100
                ? pageRawData?.activityInfo?.activityId
                : 0;

        const subsidyItem = pageRawData?.activityList?.find(v => v?.marketingActivityType === ActivityType.Exclusive);
        // 如果是1元寄样订单， 跳提单页， 新增一个标识, 并且购买数量要限定只能1个
        const channelParam = isSendSampleOrder ? { channel: 1, buyamount: 1 } : {};

        jumpToConfirmOrder({
            pageRawData,
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            sellerMerchantId: sellerMerchantId || sellerMerchantIdFromQuery,
            sellerUserId: sellerUserId || sellerUserIdFromQuery,
            poc,
            needDelay,
            flashSaleActivityId,
            halfWebview: openHalfConfirmOrder,
            minPurchase: minNum,
            retrievalInfo,
            extParamsCustom,
            backendDispatchUrl,
            ...channelParam,
            ...(hasSubsidy && subsidyItem
                ? {
                      promotionId: subsidyItem.activityId,
                      afterDiscountPrice: currentSku.activityPrice ?? pageRawData.activityPrice,
                  }
                : {}),
        });
    });
    const buyNow = useMemoizedFn(async () => {
        console.log('lock:::buyNow', lockRef.current);
        // 规格业务埋点监控

        radar.event({
            name: 'common_spec_confirm_click',
        });
        if (lockRef.current) {
            Toast.show({ text: $k18n('您的操作太频繁了') });
            return;
        }
        // 端外购买的话 需要唤起端内
        if (!isInApp) {
            return callApp({ pageId: 'ecomm_commodity_detail' });
        }

        // 未登陆需要登陆
        const res = await yoda.component.login({});
        if (res?.result !== 1) {
            return;
        }

        const skuId = currentSku.skuId;
        const skuSpecDesc = currentSku.skuSpecDesc;
        if (!skuId) {
            return;
        }
        // 购买数量超出秒杀限购的数量时，购买按钮置灰不可点
        if (skuOverActivityLimit) {
            return;
        }
        if (Number(immediateAvailableQuantity) === 0) {
            return;
        }
        const { merchantId, itemId } = currentSku;
        const buyamount = Math.max(purchaseQuantity, purchaseQuantity);
        const addressId = getStoreState().addressInfo?.addressId;
        // const extParams = getExtParams();
        if (isSendSampleOrder) {
            try {
                const autoClaimRes = await claimSelfMultiBuildCouponToB({
                    itemId,
                    coupons: [],
                    scene: 'PRODUCT_DECISION', // b端商祥场景: PRODUCT_DECISION
                });
                if (autoClaimRes.result === 1) {
                    Toast.show({
                        text: $k18n({ text: '已成功帮您领取优惠券，快来下单', id: 'k_445554' }),
                    }).finally(() => {
                        onJumpToConfirmOrder({
                            addressId,
                            buyamount,
                            merchantId,
                            skuId,
                            itemId,
                            poc: 'spec_3',
                            backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
                        });
                    });
                }

                onJumpToConfirmOrder({
                    addressId,
                    buyamount,
                    merchantId,
                    skuId,
                    itemId,
                    poc: 'spec_1',
                    backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
                });
            } catch (err) {
                console.log(err);
                onJumpToConfirmOrder({
                    addressId,
                    buyamount,
                    merchantId,
                    skuId,
                    itemId,
                    poc: 'spec_1',
                    backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
                });
            }
            return;
        }

        const is_with_coupon = pageRawData.discountCoupon && pageRawData.discountCoupon.length > 0 ? 1 : 0; // 是否是优惠券商品的购买
        const coupon_id = pageRawData.discountCoupon && pageRawData.discountCoupon.length > 0 ? `${pageRawData.discountCoupon[0].batchId}` : ''; // 券批次ID
        logClickBuyNowSpec(itemId, skuSpecDesc, skuId, coupon_id, is_with_coupon);
        onJumpToConfirmOrder({
            addressId,
            buyamount,
            merchantId,
            skuId,
            itemId,
            poc: 'spec_1',
            backendDispatchUrl: pageRawData?.pageUrl?.placeOrderJumpUrl,
        });
    });
    const { run: onThrottledAddCart } = useDebounceFn(
        () => {
            addToCart(true);
        },
        { wait: 200 }
    );
    // const onThrottledBuyNow = () => {
    //     buyNow();
    // };
    const { run: onThrottledBuyNow } = useDebounceFn(
        () => {
            buyNow();
        },
        {
            leading: true,
            trailing: false,
            wait: 500,
        }
    );

    const { run: debounceConfirm } = useDebounceFn(
        _disabled => {
            // 规格业务埋点监控
            radar.event({
                name: 'common_spec_confirm_click',
            });
            if (_disabled) return;
            customConfirm?.(currentSku, purchaseQuantity);
        },
        { wait: 200 }
    );
    const bottomAreaTip = (
        <BottomAreaTip
            {...{
                pageRawData,
                isFrom: isFrom,
                showCouponMakeUpTip: showCartAndCheckout && innerShowCartAndCheckout,
                position: 'specLinePop',
            }}
        />
    );

    const buttons = {
        buy: (
            <View>
                {/* 底部按钮上方的提示文案 */}
                {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView> : null}
                <KTouchableWithoutFeedback onPress={onThrottledBuyNow}>
                    <KView rtlClassName={rtlClassName}>
                        {isSendSampleOrder ? (
                            <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n({ id: 'k_1221700', text: '立即申样' })}</KText>
                        ) : (
                            <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('购买')}</KText>
                        )}
                    </KView>
                </KTouchableWithoutFeedback>
            </View>
        ),
        cart: (
            <View>
                {showCartAndCheckout && innerShowCartAndCheckout ? (
                    <>
                        {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                            <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView>
                        ) : null}
                        <KView rtlClassName={'optionbar_bar_btn_wrapper'}>
                            <KTouchableWithoutFeedback
                                onPress={() => {
                                    onThrottledAddCart();
                                    // 只有规格半屏内既有加购，又有购买时点击加购才上报这个埋点；
                                    logClickSpecHalfAddCart(pageRawData?.itemId);
                                }}>
                                <KView rtlClassName={miniBtnClassName}>
                                    <KText rtlClassName={'optionbar_bar_bottom_btn_black_text'}>
                                        {$k18n({ text: '加入购物车', id: 'k_355118' })}
                                    </KText>
                                </KView>
                            </KTouchableWithoutFeedback>
                            <KTouchableWithoutFeedback
                                onPress={() => {
                                    onThrottledBuyNow();
                                    // 只有规格半屏内既有加购，又有购买时点击购买才上报这个埋点；
                                    logClickSpecHalfBuyButton(pageRawData?.itemId);
                                }}>
                                <KView rtlClassName={primaryMiniBtnClassName}>
                                    <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('购买')}</KText>
                                </KView>
                            </KTouchableWithoutFeedback>
                        </KView>
                    </>
                ) : (
                    <>
                        {/* 底部按钮上方的提示文案 */}
                        {!isToBDetail && ![1, 20, -1, -10].includes(pageActiveStatus) ? (
                            <KView rtlClassName={'ugc-spec-wrap'}>{bottomAreaTip}</KView>
                        ) : null}
                        <KTouchableWithoutFeedback onPress={() => onThrottledAddCart()}>
                            <KView rtlClassName={rtlClassName}>
                                <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>
                                    {$k18n({ text: '加入购物车', id: 'add_to_cart' })}
                                </KText>
                            </KView>
                        </KTouchableWithoutFeedback>
                    </>
                )}
            </View>
        ),
        confirm: (
            <KTouchableWithoutFeedback onPress={() => debounceConfirm(disabled)}>
                <KView rtlClassName={rtlClassName}>
                    <KText rtlClassName={'optionbar_bar_bottom_btn_confirm_text'}>{$k18n('确定')}</KText>
                </KView>
            </KTouchableWithoutFeedback>
        ),
    };

    return (
        <KView
            style={{
                width: isMobileDeviceValue ? '100%' : PCMaxWidth,
            }}
            rtlClassName={'optionbar_bar'}>
            {buttons[type] || buttons.cart}
        </KView>
    );
}
